import { identity } from 'ramda'

export const playstate = identity
